import React, { useState, useEffect } from 'react';
import {
    Background,
    Container,
    Table,
    AnexoIcon,
    Header,
    Button,
    EditIcon,
    RemoveIcon,
    ScrollTable,
    ClockIcon,
    ConfigIcon,
    ClockSolicitacao,
    ShowIcon,
    Arrow,
    AddIcon,
} from './style';
import api from '../../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import GoBack from '../../../components/GoBack';
import ModalRegister from '../../../components/Modal/Operador/RegisterOcorrencia';
import { userId } from '../../../services/TokenData';
import ModalEdit from '../../../components/Modal/EditOcorrencia';
import { TruncateString } from '../../../services/TruncateString';
import { add, format, difference } from '../../../services/DateFormatter';
import Swal from 'sweetalert2';
import ModalTime from '../../../components/Modal/SolicitacaoTempo';
import ModalEditProcess from '../../../components/Modal/SolicitacaoTempoProcesso';

export default function Processo() {
    const [Dados, setDados] = useState([]);
    const [ShowModalRegister, setShowModalRegister] = useState(false);
    const [IdProcesso, setIdProcesso] = useState(0);
    const [Ocorrencia, setOcorrencia] = useState(null);
    const [ShowModalEdit, setShowModalEdit] = useState(false);
    const [Reload, setReload] = useState(false);
    const [ShowModalClock, setShowModalClock] = useState(false);
    const Location = useLocation();
    const Navigate = useNavigate();
    const UserId = userId();
    const DATA_ATUAL = new Date();
    const [Processo, setProcesso] = useState(null);
    const [ShowModalEditProcess, setShowModalEditProcess] = useState(false);
    const [expandedRow, setExpandedRow] = useState();
    const [subOcorrencias, setSubOcorrencias] = useState([]);
    const [getSubOcorrencias, setGetSubOcorrencias] = useState(null);
    const [changeColorRow, setChangeColorRow] = useState();
    const [sequencia, setSequencia] = useState(null);

    const opcao = UserId === Dados?.responsavel_id ? '/operador/solicitacoes' : '/operador/minhas_solicitacoes';
    const nameButton = UserId === Dados?.responsavel_id ? 'Solicitações' : 'Minhas Solicitações';
    const [Loading, setLoading] = useState('I');

    function deletaOcorrencia(id_processo, seq_ocorrencia, nivel_ocorrencia) {
        Swal.fire({
            title: `Deseja excluir a ocorrência ${seq_ocorrencia}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: 'var(--deep-carmine-pink)',
            cancelButtonColor: 'gray',
            confirmButtonText: 'DELETAR',
            cancelButtonText: 'CANCELAR',
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/ocorrencias/${id_processo}/${seq_ocorrencia}/${nivel_ocorrencia}`, {
                    data: { id_usuario_acao: userId() },
                }).then((res) => {
                    Swal.fire(`Ocorrencia deletada.`, '', 'success');
                    setReload(!Reload);
                });
            }
        });
    }
    function diffInDays(dataInicial, dataFinal) {
        const parseDate = (dateStr) => {
            const parts = dateStr.split('/').map(Number);
            return new Date(parts[2], parts[1] - 1, parts[0]);
        };

        const inicial = typeof dataInicial === 'string' ? parseDate(dataInicial) : dataInicial;
        const final = typeof dataFinal === 'string' ? parseDate(dataFinal) : dataFinal;

        const diffTime = final - inicial;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    function formatarData(options) {
        const { DataInicial, Formato } = options;
        const data = DataInicial;

        if (Formato === 'DD/MM/YYYY') {
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            return `${dia}/${mes}/${ano}`;
        }

        return data.toISOString().split('T')[0];
    }

    function AlertaCor(dados) {
        if (!dados) {
            return '';
        }
        const hoje = new Date();

        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const parts = dateStr.split('/').map(Number);
            return new Date(parts[2], parts[1] - 1, parts[0]);
        };

        const dataPrevista = parseDate(dados.data_prevista);
        const dataConclusao = parseDate(dados.data_conclusao);

        // Se a situação é "Concluído"
        if (dados.situacao === 'Concluído') {
            if (dataConclusao && dataPrevista) {
                const diasConclusao = diffInDays(dados.data_prevista, dados.data_conclusao);
                return diasConclusao >= 0 ? 'G' : 'O';
            }
            return '';
        }

        // Para tarefas não concluídas
        if (!dataPrevista) {
            return '';
        }

        const diasPrevistos = diffInDays(dados.data_emissao, dados.data_prevista);
        const hojeFormatado = formatarData({ DataInicial: hoje, Formato: 'DD/MM/YYYY' });
        const diasRestantes = diffInDays(hojeFormatado, dados.data_prevista);

        // Prazo vencido
        if (diasRestantes <= 0) {
            return 'R';
        }

        const limite10 = Math.ceil(diasPrevistos * 0.1);
        let limite20 = Math.ceil(diasPrevistos * 0.2);

        if (limite20 < 2) {
            limite20 = 2;
        }

        // Verificar alertas
        if (diasRestantes <= limite10 && diasRestantes >= 1) {
            return 'R';
        } else if (diasRestantes <= limite20 && diasRestantes >= 2) {
            return 'Y';
        }
        return '';
    }

    const handleClickExpandedRow = (index, seq_ocorrencia) => {
        if (index === expandedRow) {
            setExpandedRow();
            setGetSubOcorrencias(null);
            setSubOcorrencias([]);
        } else {
            setExpandedRow(index);
            setGetSubOcorrencias(seq_ocorrencia);
        }
    };

    const handleClickAdd = (dados) => {
        let dataMaximaParaAtribuicao = null;
        if (dados?.data_prevista?.includes('/')) {
            // Formato brasileiro: dd/mm/yyyy
            const [dia, mes, ano] = dados?.data_prevista?.split('/');
            const dataObj = new Date(ano, mes - 1, dia);
            dataMaximaParaAtribuicao = dataObj.toISOString().slice(0, 10); // yyyy-mm-dd
        } else if (dados?.data_prevista) {
            // Formato ISO ou outra string de data válida
            const dataObj = new Date(dados?.data_prevista);
            if (!isNaN(dataObj)) {
                dataMaximaParaAtribuicao = dataObj.toISOString().slice(0, 10); // yyyy-mm-dd
            }
        }
        const data = {
            ...dados,
            data_prevista: dataMaximaParaAtribuicao,
        };
        setSequencia(data);
        setShowModalRegister(true);
    };

    const getSubOcorrenciaAPI = async () => {
        try {
            const res = await api.get(`/processos/${Dados?.id}/ocorrencias/${getSubOcorrencias}`);
            setSubOcorrencias(res.data.subocorrencias);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        async function Request() {
            await api.get(`/processos/${Location?.state?.IdProcesso}/ocorrencias`).then((response) => {
                setDados(response?.data?.processos);
                setLoading('V');
            });
        }
        Request();
        setIdProcesso(Location?.state?.IdProcesso);
    }, [Location?.state?.IdProcesso, Reload]);

    useEffect(() => {
        if (!getSubOcorrencias) return;

        getSubOcorrenciaAPI();
    }, [getSubOcorrencias, Reload]);

    const temPermissao = (d) => {
        const idsPermitidos = new Set();

        if (d?.id_destinatario) idsPermitidos.add(d.id_destinatario);
        if (d?.id_remetente) idsPermitidos.add(d.id_remetente);

        if (subOcorrencias?.length) {
            subOcorrencias
                ?.filter((sub) => sub?.seq_ocorrencia === d?.seq_ocorrencia)
                ?.forEach((sub) => {
                    if (sub?.id_destinatario) idsPermitidos.add(sub.id_destinatario);
                    if (sub?.id_remetente) idsPermitidos.add(sub.id_remetente);
                });
        }

        return idsPermitidos.has(UserId);
    };

    return (
        <Background>
            <GoBack />
            <Container>
                <Header>
                    <Button onClick={() => setShowModalRegister(true)} className={Loading}>
                        Novo
                    </Button>
                    <h1>Lista de Ocorrências</h1>
                    <div style={{ width: '100px' }}></div>
                </Header>

                <ScrollTable>
                    <Table className="info">
                        <tr>
                            <th style={{ width: '14%' }}>Processo Nº : {Dados?.numero}</th>
                            <th style={{ width: '72%' }}>Assunto: {Dados?.assunto}</th>
                            <th style={{ width: '14%' }}>
                                Data Prevista:{' '}
                                {format({
                                    DataInicial: add({
                                        DataInicial: Dados?.data_inicio,
                                        Valor: Dados?.dias_previstos,
                                        FormatoValor: 'D',
                                    }),
                                    Formato: 'DD/MM/YYYY',
                                })}
                            </th>
                            <th>
                                {UserId === Dados?.responsavel_id ? (
                                    <ConfigIcon
                                        onClick={() => {
                                            setProcesso(Dados);
                                            setShowModalEditProcess(true);
                                        }}
                                    />
                                ) : (
                                    ''
                                )}
                            </th>
                        </tr>
                    </Table>
                </ScrollTable>
                <ScrollTable>
                    <Table>
                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: 'var(--table-primary-color)',
                                width: '100%',
                                border: '2px solid white',
                            }}
                        >
                            <tr>
                                <th></th>
                                <th>Seq.</th>
                                <th>Remetente</th>
                                <th>Destinatario</th>
                                <th>Descrição</th>
                                <th>Data Inicial</th>
                                <th>Data Prevista</th>
                                <th>Data Conclusão</th>
                                <th>Situação</th>
                                <th>Dias Restantes</th>
                                <th>Anexos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Dados?.ocorrencias?.map((d, i) => (
                                <React.Fragment>
                                    <tr key={i}>
                                        <td onClick={() => handleClickExpandedRow(i, d.seq_ocorrencia)} style={{ width: 'fit-content' }}>
                                            <Arrow expandedRow={expandedRow === i} />
                                        </td>
                                        <td>{d?.seq_ocorrencia}</td>
                                        <td title={d?.nome_remetente}>{TruncateString(d?.nome_remetente, 10)}</td>
                                        <td title={d?.nome_destinatario}>{TruncateString(d?.nome_destinatario, 10)}</td>
                                        <td title={d?.descricao}>{TruncateString(d?.descricao, 30)}</td>
                                        <td>{d?.data_emissao}</td>
                                        <td>{d?.data_prevista}</td>
                                        <td>{d?.data_conclusao || '-'}</td>
                                        <td className={AlertaCor(d)}>{d?.situacao}</td>
                                        <td className={AlertaCor(d)}>
                                            {d?.situacao === 'Concluído'
                                                ? '-'
                                                : diffInDays(
                                                        format({ DataInicial: new Date(d?.data_emissao), Formato: 'DD/MM/YYYY' }),
                                                        d?.data_prevista
                                                    ) < 0
                                                  ? 0
                                                  : diffInDays(
                                                        format({ DataInicial: new Date(d?.data_emissao), Formato: 'DD/MM/YYYY' }),
                                                        d?.data_prevista
                                                    )}
                                        </td>
                                        <td>
                                            {!d?.anexos || (
                                                <AnexoIcon
                                                    title="Ver Anexos"
                                                    onClick={() =>
                                                        Navigate('/operador/anexos', {
                                                            state: {
                                                                NumProcesso: Dados?.numero,
                                                                IdProcesso: Dados?.id,
                                                                Seq: d?.seq_ocorrencia,
                                                                Desc: d?.descricao,
                                                            },
                                                        })
                                                    }
                                                />
                                            )}
                                        </td>
                                        {(d?.id_remetente === UserId || d?.id_destinatario === UserId) && (
                                            <td>
                                                <EditIcon
                                                    className={UserId === d?.id_destinatario ? 'V' : UserId === Dados?.responsavel ? 'V' : 'I'}
                                                    title="Editar Ocorrência?"
                                                    onClick={() => {
                                                        setOcorrencia(d);
                                                        setShowModalEdit(true);
                                                    }}
                                                />
                                            </td>
                                        )}
                                        <td>
                                            {d?.id_destinatario === UserId && (
                                                <ClockIcon
                                                    className={UserId === d?.id_destinatario ? 'V' : UserId === Dados?.responsavel ? 'V' : 'I'}
                                                    title="Solicitar Prorrogação de Prazo?"
                                                    onClick={() => {
                                                        setOcorrencia(d);
                                                        setShowModalClock(true);
                                                    }}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            {d?.id_remetente === UserId && (
                                                <RemoveIcon
                                                    className={UserId === d?.id_destinatario ? 'V' : UserId === Dados?.responsavel ? 'V' : 'I'}
                                                    title="Exluir ocorrência?"
                                                    onClick={() => {
                                                        deletaOcorrencia(Dados?.id, d?.seq_ocorrencia);
                                                    }}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    {expandedRow === i && subOcorrencias?.length > 0 ? (
                                        <>
                                            {subOcorrencias?.map((sub) => (
                                                <tr key={sub?.id_ocorrencia_sub}>
                                                    {' '}
                                                    {/* Adicione key única se possível */}
                                                    <td></td>
                                                    <td className={AlertaCor(sub)}>
                                                        {sub?.seq_ocorrencia}.{sub?.nivel_ocorrencia}
                                                    </td>
                                                    <td>{sub?.nome_remetente}</td>
                                                    <td>{sub?.nome_destinatario}</td>
                                                    <td>{sub?.descricao}</td>
                                                    <td>{sub?.data_emissao}</td>
                                                    <td>{sub?.data_prevista}</td>
                                                    <td>{d?.data_conclusao || '-'}</td>
                                                    <td className={AlertaCor(sub)}>{sub?.situacao}</td>
                                                    <td className={AlertaCor(sub)}>
                                                        {sub?.situacao === 'Concluído'
                                                            ? '-'
                                                            : diffInDays(
                                                                    format({ DataInicial: new Date(), Formato: 'DD/MM/YYYY' }),
                                                                    sub?.data_prevista
                                                                ) < 0
                                                              ? 0
                                                              : diffInDays(
                                                                    format({ DataInicial: new Date(), Formato: 'DD/MM/YYYY' }),
                                                                    sub?.data_prevista
                                                                )}
                                                    </td>
                                                    <td>
                                                        {!sub?.anexos || (
                                                            <AnexoIcon
                                                                title="Ver Anexos"
                                                                onClick={() =>
                                                                    Navigate('/operador/anexos', {
                                                                        state: {
                                                                            NumProcesso: Dados?.numero,
                                                                            IdProcesso: Dados?.id,
                                                                            Seq: sub?.seq_ocorrencia,
                                                                            Desc: sub?.descricao,
                                                                        },
                                                                    })
                                                                }
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        {(UserId === sub?.id_remetente || UserId === sub?.id_destinatario) && (
                                                            <ShowIcon
                                                                onClick={() => {
                                                                    setOcorrencia(sub);
                                                                    setShowModalEdit(true);
                                                                }}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        {UserId === sub?.id_destinatario && (
                                                            <ClockIcon
                                                                onClick={() => {
                                                                    setOcorrencia(sub);
                                                                    setShowModalClock(true);
                                                                }}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        {UserId === sub?.id_remetente && (
                                                            <RemoveIcon
                                                                title="Excluir"
                                                                onClick={() => {
                                                                    deletaOcorrencia(Dados?.id, sub?.seq_ocorrencia, sub?.nivel_ocorrencia);
                                                                }}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        expandedRow === i && (
                                            <>
                                                <tr style={{ border: 'none' }}>
                                                    <td colSpan={14}></td>
                                                </tr>
                                                <tr style={{ borderBottom: 'none', borderTop: 'none' }}>
                                                    <td colSpan={16} style={{ textAlign: 'center', fontWeight: 600 }}>
                                                        Nenhuma subocorrência encontrada.
                                                    </td>
                                                </tr>
                                                <tr style={{ border: 'none' }}>
                                                    <td colSpan={14}></td>
                                                </tr>
                                            </>
                                        )
                                    )}
                                    {expandedRow === i && temPermissao(d) && (
                                        <>
                                            <tr>
                                                <td colSpan={15} style={{ textAlign: 'center', padding: '10px' }}>
                                                    <Button
                                                        style={{
                                                            backgroundColor: 'green',
                                                            fontWeight: '700',
                                                            padding: '2px 10px',
                                                            textTransform: 'none',
                                                        }}
                                                        onClick={() => handleClickAdd(d)}
                                                    >
                                                        <div>
                                                            <AddIcon size={21} />
                                                            <p>Adicionar</p>
                                                        </div>
                                                    </Button>
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                    {expandedRow === i && (
                                        <tr style={{ border: 'none', backgroundColor: 'var(--secondary-bg-color)' }}>
                                            <td colSpan={16} style={{ border: 'none', backgroundColor: 'var(--secondary-bg-color)' }}></td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </ScrollTable>
                <span className="legenda">
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--alerta-vermelho-color)',
                                color: 'var(--alerta-vermelho-color)',
                            }}
                        >
                            ______
                        </div>
                        <p>Atenção</p>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--alerta-amarelo-color)',
                                color: 'var(--alerta-amarelo-color)',
                            }}
                        >
                            ______
                        </div>
                        <p>Alerta</p>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--sandy-brown)',
                                color: 'var(--sandy-brown)',
                            }}
                        >
                            ______
                        </div>
                        <p>Concluído com atraso</p>
                    </div>
                    <div>
                        <div
                            style={{
                                backgroundColor: 'var(--pastel-green)',
                                color: 'var(--pastel-green)',
                            }}
                        >
                            ______
                        </div>
                        <p>Concluído no prazo</p>
                    </div>
                </span>
            </Container>
            <ModalRegister
                Show={ShowModalRegister}
                setShow={setShowModalRegister}
                NumProcesso={Dados?.numero}
                setReload={setReload}
                Reload={Reload}
                IdProcesso={Dados?.id}
                Dados={Dados}
                sequencia={sequencia}
                setSequencia={setSequencia}
            />
            <ModalEdit
                Show={ShowModalEdit}
                setShow={setShowModalEdit}
                Reload={Reload}
                setReload={setReload}
                DadosOcorrencia={Ocorrencia}
                DadosProcesso={Dados}
            />
            <ModalTime
                Show={ShowModalClock}
                setShow={setShowModalClock}
                Reload={Reload}
                setReload={setReload}
                DadosOcorrencia={Ocorrencia}
                DadosProcesso={Dados}
            />
            <ModalEditProcess
                Show={ShowModalEditProcess}
                Reload={Reload}
                setShow={setShowModalEditProcess}
                setReload={setReload}
                Dados={Dados}
                IdResponsavel={UserId}
            />
        </Background>
    );
}
